import { Plugin } from 'vue'
import VCalendar from 'v-calendar'
import 'v-calendar/style.css'

export default {
  install(app) {
    // The week starts on Sunday in each calendar's first-day-of-week prop
    app.use(VCalendar, {
      titlePosition: 'left',
    })
  },
} as Plugin
